// @ts-nocheck
import { get, post } from "@insite/client-framework/Services/ApiService";
import { MailChimpMemberInterestsModel, MailChimpMemberResponseModel } from "@store/Framework/Types/ApiModels";

const serviceUri = "/api/v1/mailchimp/";

export async function getIsConfigured() {
    const isConfigured = await get<boolean>(`${serviceUri}getisconfigured`);
    return isConfigured;
}

export async function getMemberInfo(email: string) {
    const memberInfo = await get<MailChimpMemberInterestsModel>(`${serviceUri}${email}/getmemberinfo`);
    return memberInfo;
}

export async function setMemberInfo(memberInfo: MailChimpMemberInterestsModel): Promise<MailChimpMemberResponseModel> {
    try {
        const response = await post<MailChimpMemberInterestsModel, MailChimpMemberResponseModel>(
            `${serviceUri}setmemberinfo`,
            memberInfo,
        );
        return response;
    } catch (error) {
        return error;
    }
}
